<template>
  <div class="form-btns">
    <a
      class="cancel-btn"
      href="javascript:void(0)"
      @click.prevent="$emit('reject')"
      ><span class="fas fa-times"></span
    ></a>
    <a
      class="ok-btn"
      href="javascript:void(0)"
      @click.prevent="$emit('confirm')"
      ><span class="fa fa-check"></span
    ></a>
  </div>
</template>

<script>
export default {
  name: "ConfirmIconButtons.component"
};
</script>

<style scoped>
.form-btns {
  display: flex;
  width: 60px;
}

.cancel-btn {
  color: red !important;
  margin: auto;

  font-size: 12pt;
}

.ok-btn {
  color: green !important;
  margin: auto;
}
</style>
